"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowContext = exports.WorkflowProvider = exports.WorkflowContext = void 0;
var react_1 = __importStar(require("react"));
/**
 * The current workflow context that can be used by child components to inspect and control the current workflow.
 */
exports.WorkflowContext = react_1.default.createContext(null);
/**
 * Set the workflow context for children in the React tree.
 */
function WorkflowProvider(props) {
    var children = props.children, currentStep = props.currentStep;
    return react_1.default.createElement(exports.WorkflowContext.Provider, { value: { currentStep: currentStep } }, children);
}
exports.WorkflowProvider = WorkflowProvider;
/**
 * Grab the value of the current workflow context.
 */
function useWorkflowContext() {
    var value = (0, react_1.useContext)(exports.WorkflowContext);
    if (!value) {
        throw new Error('Missing WorkflowStepContext');
    }
    return value;
}
exports.useWorkflowContext = useWorkflowContext;
